import sortBy from 'lodash/fp/sortBy';
import classNames from "classnames";

import SectionLoading from "../../../../../../components/SectionLoading";
import { Promotion } from "../../../../../../models/Promotion";
import { apiGetPromotions } from "../../../../../../utils/api";
import { swapArrayLocs } from '../../../../../../utils/utils';
import { DComponent } from '../../../../../../components/DComponent';

export default class CouponModal extends DComponent {
  constructor({
    parent,
    id,
    orderCode = "",
    promotionCode,
    onApply = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("CouponModal"),
    }, true);
    this.promotionCode = promotionCode;
    this.orderCode = orderCode;
    this.onApply = onApply;
    /** @type {SectionLoading} */
    this.promotionLoading = undefined;
    /** @type {[Promotion]} */
    this.listPromotions = [];
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "CouponModal");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.promotionLoading = new SectionLoading({ parent: $(".modal-content", this.element) });
    this.addEventListener();
  }

  addEventListener() {
    $(".coupon-list .list-data", this.element).on("scroll", (e) => {
      if (e.target.scrollTop + 24 >= e.target.scrollHeight - e.target.clientHeight) {
        $(".coupon-list .blur-div", this.element).addClass("hide");
      } else {
        $(".coupon-list .blur-div", this.element).removeClass("hide");
      }
    });

    $(this.element).on('hide.bs.modal', () => {
      $("html, body").css("overflow", "auto");
    })
  }

  onShow(promotionCode) {
    this.promotionCode = promotionCode;
    this.getPromotions();
    $("html, body").css("overflow", "hidden");
    this.element.modal("toggle");
  }

  onHide() {
    $("html, body").css("overflow", "auto");
    this.element.modal("hide");
  }

  setOrderCode(code) {
    this.orderCode = code;
  }

  getPromotions(params = {}) {
    $(".coupon-list .list-data", this.element).html("");
    this.promotionLoading.show();
    apiGetPromotions({
      paging: 1,
      per_page: 20,
      order_id: this.orderCode,
    }, (data) => {
      if (data.data && data.data.length) {
        let listPromotions = Promotion.fromApiArray(data.data);
        if (params.code) {
          let selectedInd = listPromotions.findIndex(item => item.code === params.code);
          if (selectedInd > -1) {
            swapArrayLocs(listPromotions, 0, selectedInd)
          }
        }
        this.listPromotions = sortBy(({ startAt }) => startAt * 1000 < Date.now() ? 0 : 1, listPromotions);
        let htmlCoupon = ""
        this.listPromotions.forEach(element => {
          htmlCoupon += this.genHtmlCoupon(element, this.promotionCode === element.code)
        });
        if (this.listPromotions.length > 4) {
          $(".coupon-list .blur-div", this.element).removeClass("hide");
        }
        $(".coupon-list .list-data", this.element).html(htmlCoupon)
        $(".coupon-list", this.element).removeClass("empty")
        $(".coupon-list .apply-coupon", this.element).on("click", (e) => {
          let ac = $(e.target).data("ac");
          if (ac !== "disabled") {
            let pc = $(e.target).data("pc");
            typeof this.onApply === "function" && this.onApply(pc);
            this.onHide();
          }
        });

        $(".coupon-list .coupon-info", this.element).on("click", (e) => {
          if ($(e.target).attr("aria-expanded") === "false") {
            let parent = $(e.target).parentsUntil(".list-data").last()[0];
            $(".list-data", this.element).animate({
              scrollTop: parent.offsetTop
            }, 500)
          }
        })
      } else {
        $(".coupon-list", this.element).addClass("empty")
      }
      this.promotionLoading.hide();
    }, (error) => {
      $(".coupon-list", this.element).addClass("empty")
      this.promotionLoading.hide();
    });
  }


  genHtmlCoupon(element, isActive = false) {
    let expired = element.endAt && element.endAt * 1000 < Date.now();
    let notYet = element.startAt && element.startAt * 1000 > Date.now();
    if (expired) return '';
    let htmlTags = "";
    if (element.tags && element.tags.length > 0) {
      element.tags.forEach((item, index) => (
        htmlTags += `<span key="${index}">● ${item}</span>`
      ))
    }
    return `
    <div class="coupon-item-box${notYet ? " disabled" : (isActive ? " active" : "")}">
      <div class="coupon-item">
        <div class="coupon-info" data-toggle="collapse" data-target="#coupon_detail_${element.id}" aria-expanded="false">
          <div class="coupon-icon">
            <img alt="icon-coupon" src="${element.iconUrl || require("../../../../../../assets/images/checkout/coupon_icon_default.svg")}" />
          </div>
          <div class="coupon-description">
            ${htmlTags ? `<div class="coupon-label">${htmlTags}</div>` : ""}
            <div class="coupon-title">${element.name}</div>
            <div class="coupon-bottom">
              ${notYet ? `
              <div class="coupon-date">
                <span data-i18n="checkout_startFrom">${$.i18n("checkout_startFrom")}</span>
                <span class="value">${window.moment(element.startAt * 1000).format("DD/MM/YYYY")}</span>
              </div>` : element.endAt ? `
              <div class="coupon-date">
                <span data-i18n="checkout_validUntil">${$.i18n("checkout_validUntil")}</span>
                <span class="value">${window.moment(element.endAt * 1000).format("DD/MM/YYYY")}</span>
              </div>` : ""}
              <div data-i18n="checkout_details" class="details" data-toggle="collapse" data-target="#coupon_detail_${element.id}" aria-expanded="false">
              ${$.i18n("checkout_details")}
              </div>
            </div>
          </div>
        </div>
        <div class="apply-coupon" data-pc="${element.code}" data-ac="${notYet || isActive ? "disabled" : ""}">
          <span data-pc="${element.code}" data-ac="${notYet || isActive ? "disabled" : ""}" class="btn-ok" data-i18n="[html]${isActive && !notYet ? "checkout_applied" : "checkout_apply"}">${isActive && !notYet ? $.i18n("checkout_applied") : $.i18n("checkout_apply")}</span>
        </div>
      </div>
    </div>
    <div id="coupon_detail_${element.id}" class="collapse coupon-detail${isActive ? " show" : ""}">
      <img class="close close-detail" alt="close" src="${require("../../../../../../assets/images/icons/Close_dark.svg")}"
        data-toggle="collapse" data-target="#coupon_detail_${element.id}" aria-expanded="false" />
      <div data-i18n="checkout_couponTerm" class="coupon-term">${$.i18n("checkout_couponTerm")}</div>
      <div class="value">${element.description}</div>
    </div>
  `
  }
}